module.exports = __webpack_public_path__ + "static/img/map_hainan.e7dd823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_hainan.png
// module id = tjzl
// module chunks = 0